import { ReactNode } from 'react';
import styled from 'styled-components';
import styles from './center.module.css';

interface LXCenterProps {
  children: ReactNode;
}
const LXCenter: React.FC<LXCenterProps> = (props) => {
  return <div className={styles.containerCenter}>{props.children}</div>;
};

export default LXCenter;

export const XCenter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
